import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "headTable", "opportunityLeadName",
                    "countOneCheckbox", "countOne", "countTwoCheckbox", "payableHeader"]

  connect() {
    this.controllerName = `financials--books--payables--annual--index`
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.itemsOnPage = 300
    this.pageNumber = 0
    this.numberPages = []
    this.sort = { mode: `asc`, field: `token` }
    this.hasShow = false
    this.tableCols = 14
    this.doAccounts()
  }

  doIndexListHtml() {

    var clearBtnHtml = ``

    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" style="font-size:80%;">
                          <thead data-${this.controllerName}-target="headTable"></thead>
                          <tbody data-${this.controllerName}-target="bodyTable"></tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--books--payables--annual--dashboard").listTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.65) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 10))
      controller.doTableHead()
      controller.doDataTable()
    })
  }

  doTableHead() {

    this.application.dates.forEach((element, index) => {
      if (this.application.current_date.id == element.id) {
        this.application.dates.slice(index, 12 + index).forEach(element => {
          this.application.annual_payables[this.application.annual_payables.length] = element
        })
      }
    })

    var monthsHtml = ``

    this.application.annual_payables.forEach(element => {
      monthsHtml += `<th scope="col" class="pointer p-1 table-7 align-middle text-center">${element.date_pretty}</th>`
    })
    // style="font-size:80%;"

    this.headTableTarget.innerHTML = `<tr>
                                        <th colspan="2" scope="col" class="pointer p-1 align-middle table-8">
                                          Contas
                                        </th>
                                        ${monthsHtml}
                                      </tr>`

  }

  doDataTable() {
    var accountsHtml = ``

    this.accounts.forEach(accountElement => {
      accountsHtml += this.payableTablePartial(accountElement)
    })

    this.bodyTableTarget.innerHTML = accountsHtml

  }

  payableTablePartial(accountElement) {
    var payablesHtml = ``

    var highlight = ``
    var spaceRow = ``
    var borderHighlight = ``
    if (accountElement.highlight) {
      highlight = `f-bold`
      spaceRow = `<tr><td colspan="14" style="height:2rem;padding-top:1rem;padding-bottom:1rem;" scope="col"></td></tr>`
      borderHighlight = `border-highlight`
    }

    this.application.annual_payables.forEach(dateElement => {
      payablesHtml += `<td style="font-size:90%;" scope="col" class="p-1 align-middle text-center ${highlight}">${this.controllerNumber.currencyOptionMask(dateElement.payable_compilation[accountElement.name])}</td>`
    })

    var rowHtml = `${spaceRow}
                  <tr class="itemRow ${borderHighlight}">
                    <td colspan="2" style="font-size:100%;" scope="col" class="p-1 align-middle ${highlight}">${accountElement.name_pretty}</td>
                    ${payablesHtml}
                  </tr>
                  ${spaceRow}`

    return rowHtml
  }

  doAccounts() {
    this.accounts = [
                      {
                        name: `total_amount`,
                        name_pretty: `Total À Pagar`,
                        highlight: false,
                      },
                      {
                        name: `total_paid_amount`,
                        name_pretty: `Total Pago`,
                        highlight: true,
                      },
                      {
                        name: `commercial_staff_expenses`,
                        name_pretty: `Pessoal Comercial`,
                        highlight: false,
                      },
                      {
                        name: `operation_staff_expenses`,
                        name_pretty: `Pessoal Operação`,
                        highlight: false,
                      },
                      {
                        name: `technology_staff_expenses`,
                        name_pretty: `Pessoal Tecnologia`,
                        highlight: false,
                      },
                      {
                        name: `administrative_staff_expenses`,
                        name_pretty: `Pessoal Administrativo`,
                        highlight: false,
                      },
                      {
                        name: `general_staff_expenses`,
                        name_pretty: `Pessoal Geral`,
                        highlight: false,
                      },
                      {
                        name: `total_staff_expenses`,
                        name_pretty: `Total Pessoal`,
                        highlight: true,
                      },
                      {
                        name: `sales_expenses`,
                        name_pretty: `Despesas de Vendas`,
                        highlight: false,
                      },
                      {
                        name: `marketing_expenses`,
                        name_pretty: `Despesas de Marketing`,
                        highlight: false,
                      },
                      {
                        name: `services_expenses`,
                        name_pretty: `Despesas com Operação`,
                        highlight: false,
                      },
                      {
                        name: `technology_expenses`,
                        name_pretty: `Despesas de Tecnologia`,
                        highlight: false,
                      },
                      {
                        name: `administrative_expenses`,
                        name_pretty: `Despesas Administrativas`,
                        highlight: false,
                      },
                      {
                        name: `financial_expenses`,
                        name_pretty: `Despesas Financeiras`,
                        highlight: false,
                      },
                      {
                        name: `general_expenses`,
                        name_pretty: `Despesas Gerais`,
                        highlight: false,
                      },
                      {
                        name: `grant_losses_realization`,
                        name_pretty: `Despesas com Perdas`,
                        highlight: false,
                      },
                      {
                        name: `grant_depreciation_expenses`,
                        name_pretty: `Depreciação`,
                        highlight: false,
                      },
      
    ]
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
